"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewKeyToString = viewKeyToString;
exports.uriToViewKey = uriToViewKey;
const vscode_uri_1 = require("vscode-uri");
/**
 * Serializes a view key to a URI-compatible string.
 *
 * The base of the URI is that of the source document. If present, the document's scheme is replaced
 * with {@code view+<doc scheme>}. If the {@code pluginId} and/or {@code viewId} are present, they
 * are appended as query params.
 */
function viewKeyToString(key) {
    let uri = vscode_uri_1.URI.parse("view:/");
    if (key.docUri) {
        const docUri = vscode_uri_1.URI.parse(key.docUri);
        uri = docUri.with({ scheme: `${uri.scheme}+${docUri.scheme}` });
    }
    let query = [
        key.pluginId && `pluginId=${key.pluginId}`,
        key.viewId && `viewId=${key.viewId}`,
    ].filter((i) => i);
    if (query.length) {
        uri = uri.with({ query: query.join("&") });
    }
    return decodeURIComponent(uri.toString());
}
/** Deserializes a ViewKey URI into a ViewKey. */
function uriToViewKey(uri) {
    const docUri = uri
        .with({ scheme: uri.scheme.replace(/^view\+/, ""), fragment: null, query: null })
        .toString();
    const query = decodeURIComponent(uri.query);
    return {
        docUri: decodeURIComponent(docUri),
        pluginId: query.match(/pluginId=(\w+)/)?.[1] || "",
        viewId: query.match(/viewId=(\w+)/)?.[1] || "",
    };
}
